import CheckIcon from './check-icon.js';

const Header = () => {
  return (
    <div className="size-[100px] rounded-full bg-[linear-gradient(65.39deg,#9B6FFA_21.25%,rgba(210,147,246,0.5)_42.5%,rgba(254,218,191,0.5)_55.7%,rgba(255,255,255,0)_74.76%)] p-[10px] theme-dark:bg-[linear-gradient(89.78deg,#8E59FF_2.18%,rgba(210,147,246,0.5)_31.1%,rgba(0,0,0,0)_76.25%)]">
      <div className="relative flex size-full items-center justify-center rounded-full shadow-sm *:z-[1] before:absolute before:inset-0 before:rounded-full before:bg-white before:bg-[linear-gradient(180deg,transparent_0%,rgba(21,21,21,0.09)_68.12%)] after:absolute after:inset-px after:rounded-full after:bg-white">
        <CheckIcon />
      </div>
    </div>
  );
};

export default Header;
